<template>
    <modal :id="id" :loading="loading" :saveing="saveing" @shown="shown" @ok="save" @cancel="cancel">
        <span slot="modal-title">學生朝會出席統計表</span>
        <div class="row">
            <div class="col-md-6 col-sm-12">
                <form-input v-model="vm.SYear" id="SYear" label="學年度" type="number" required></form-input>
            </div>
            <div class="col-md-6 col-sm-12">
                <form-select v-model="vm.Semester" id="Semester" label="學期" required>
                    <div is="option" value="u">上</div>
                    <div is="option" value="d">下</div>
                </form-select>
            </div>
            <div class="col-12">
                <form-input v-model="vm.ClassID" id="ClassID" label="班級" type="text" classlist required></form-input>
            </div>
            <div class="col-12">
                <form-date-input v-model="vm.Date" id="Date" label="日期" required></form-date-input>
            </div>
            <div class="col-md-4 col-sm-12">
                <form-input v-model="vm.Should" id="Should" label="應到人數" type="number" required></form-input>
            </div>
            <div class="col-md-4 col-sm-12">
                <form-input v-model="vm.NoArrive" id="NoArrive" label="未到人數" type="number" required></form-input>
            </div>
            <div class="col-md-4 col-sm-12">
                <form-input v-model="vm.Exempt" id="Exempt" label="自治幹部、宿委幹部、免朝會人數" type="number" required></form-input>
            </div>
        </div>
    </modal>
</template>

<script>
    import { detail } from '@/views';
    export default detail({
        name: 'morningmeetingStudentDetail',
        api: '/api/morningmeetingstudent/'
    });
</script>

<style>
</style>